import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from "@material-ui/core/styles";
import CloseButtonDialog from './CloseButtonDialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { Typography } from '@material-ui/core';
import { TipoDoc } from 'App/Helpers/Iconos';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import LinearProgress from '@material-ui/core/LinearProgress';
import _ from 'underscore';
import { CesionContext } from 'App/Cesion/store';
import axios from 'axios';
import { formateaRut, DigitoVerificador, separadorMiles, useDateInput, useFormInput } from 'App/Helpers/Genericos'
import Autocomplete from 'App/components/Autocomplete';
import { GetContribuyentes } from 'App/Emitidos/Actions';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { LayoutContext } from "App/Layout/store";

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    progress: {
        padding: theme.spacing.unit * 2,
    },
});

function Cesion(props) {
    const { classes } = props;
    const [cargando, setCargando] = useState(false);
    const [enviando, setEnviando] = useState(false);
    const [DatosCeder, setDatosCeder] = useState({});
    const [rutAut, setRutAut] = useState("");
    const [clientesSuggestion, setClientesSuggestion] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [cliente, setCliente] = useState({});
    const [cargandoClientes, setCargandoClientes] = useState(false);
    const [monto, setMonto] = useState("");
    const vencimiento = useDateInput(null, 'Vencimiento');
    const otrasCondiciones = useFormInput("", 'Otras Condiciones');
    const emailDeudor = useFormInput("", 'Email Deudor');
    const emailCesionario = useFormInput("", 'Email Cesionario');
    const direccionCesionario = useFormInput("", 'Dirección Cesionario');
    const direccionCedente = useFormInput("", 'Dirección Cedente');
    const emailCedente = useFormInput("", 'Email Cedente');

    const cesionContext = useContext(CesionContext);
    const layoutContext = useContext(LayoutContext);

    function handleToggleModal() {
        cesionContext.dispatch({ type: "toggleCesion" });
    }
    function EnviaCesion(e){
        e.preventDefault();
        if(!direccionCedente.value){
            alert("Debe ingresar la dirección del Cedente");
            return;
        }
        if(!emailCedente.value){
            alert("Debe ingresar el correo del Cedente");
            return;
        }
        if(!cliente.Rut){
            alert("Debe seleccionar un Cesionario");
            return;
        }
        if(!emailCesionario.value){
            alert("Debe ingresar el correo del Cesionario");
            return;
        }
        if(!direccionCesionario.value){
            alert("Debe ingresar la dirección del Cesionario");
            return;
        }
        if(monto > (cesionContext.state.documento.total || 0)){
            alert("El monto a ceder debe ser menor al total del documento");
            return;
        }
        if(vencimiento.value && new Date(new Date(vencimiento.value).toLocaleDateString()) < new Date(new Date(cesionContext.state.documento.fecha_emision).toUTCString())){
            alert("El vencimiento debe ser mayor o igual a la fecha de emisión del documento");
            return;
        }
        var datos = {
            id_dte: cesionContext.state.documento.id_dte,
            rutCesionario: cliente.Rut,
            direccionCesionario: direccionCesionario.value,
            emailCesionario: emailCesionario.value,
            direccionCedente: direccionCedente.value,
            emailCedente: emailCedente.value,
        }
        if(monto>0){
           datos.monto = monto; 
        }
        if(vencimiento.value){
            datos.vencimiento = vencimiento.value;
        }
        if(otrasCondiciones.value){
            datos.otrasCondiciones = otrasCondiciones.value;
        }
        if(emailDeudor.value){
            datos.emailDeudor = emailDeudor.value;
        }
        layoutContext.dispatch({
            type: "setAlert", Alert: {
                Accion: () => {
                    setEnviando(true);
                    axios.post("/api/DTE/Cesion/Ceder",datos).then(()=>handleToggleModal()).catch(e => /*alert(e.response.data.Mensaje)*/{}).finally(() => setEnviando(false));
                },
                titulo: "Confirmar Cesión",
                contenido: <div>
                    <p>Está seguro que desea ceder este documento con las condiciones ingresadas?</p>
                </div>
            }
        })
    }

    useEffect(() => {
        if (cesionContext.state.openCesion) {
            setCargando(true)
            axios.get("/api/DTE/Cesion/Datos/" + cesionContext.state.documento.id_dte).then(r => { setDatosCeder(r); setRutAut(r.rutRemitente + "-" + DigitoVerificador(r.rutRemitente)); direccionCedente.onChange({ target: { value: r.Direccion } }); emailCedente.onChange({ target: { value: r.Email } }) }).catch(e => console.error(e)).finally(() => setCargando(false));
        } else {
            setCliente({})
        }
    }, [cesionContext.state.openCesion])

    var content =
        <Grid container spacing={24}>
            {(DatosCeder.Cesiones || []).length > 0 ?
                <Grid item xs={12}>
                    <ExpansionPanel fullWidth>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <div className={classes.column}>
                                <Typography variant="subtitle1">Cesiones Anteriores</Typography>
                            </div>
                            {/* <div className={classes.column}>
                            <Typography className={classes.secondaryHeading}>Select trip destination</Typography>
                        </div> */}
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className={classes.details}>
                            {DatosCeder.Cesiones.map(c => {
                                return <Grid container>
                                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="RUT Cesionario" InputProps={{ readOnly: true }} variant="filled" value={c.Rut + "-" + DigitoVerificador(c.Rut)} fullWidth /></Typography></Grid>
                                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Razón Social Cesionario" InputProps={{ readOnly: true }} variant="filled" value={c.RazonSocial || ""} fullWidth /></Typography></Grid>
                                </Grid>
                            })}
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid> : null}
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>Datos Cedente</Typography>
                <Grid container>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="RUT Cedente" InputProps={{ readOnly: true }} variant="filled" value={DatosCeder.Rut + "-" + DigitoVerificador(DatosCeder.Rut)} fullWidth /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Razón Social Cedente" InputProps={{ readOnly: true }} variant="filled" value={DatosCeder.RazonSocial} fullWidth /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...direccionCedente} /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...emailCedente} /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="RUT Autorizado por Cedente" InputProps={{ readOnly: true }} variant="filled" value={rutAut} onChange={e => setRutAut(formateaRut(e.target.value).replace(/\./g, ""))} fullWidth /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Nombre Autorizado por Cedente" InputProps={{ readOnly: true }} variant="filled" defaultValue={DatosCeder.nombreRemitente} fullWidth /></Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>Datos Cesion</Typography>
                <Grid container>
                    <Grid xs={6}>
                        <Typography style={{ margin: 8 }} >
                            <Autocomplete
                                label="Cesionario"
                                suggestions={clientesSuggestion}
                                placeholder="Nombre o RUT de Cesionario"
                                isMulti={false}
                                cargando={cargandoClientes}
                                inputChange={_.debounce((nombre) => {
                                    setCargandoClientes(true);
                                    GetContribuyentes(nombre.trim(), (clientes) => {
                                        setClientes(clientes);
                                        setClientesSuggestion(_.map(clientes, (cliente) => { return { label: cliente.RazonSocial, value: cliente.Rut } }));
                                        setCargandoClientes(false);
                                    });
                                }, 500)}
                                value={cliente == "" ? null : { label: cliente.RazonSocial, value: cliente.Rut }}
                                onChange={(selected) => {
                                    var contribuyente = _.find(clientes, { Rut: selected.value });
                                    setCliente(contribuyente);
                                    emailCesionario.onChange({ target: { value: contribuyente.Correo || "" } });
                                    direccionCesionario.onChange({ target: { value: contribuyente.Direccion || "" } });
                                }}
                            />
                        </Typography>
                    </Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="RUT Cesionario *" InputProps={{ readOnly: true }} variant="filled" value={cliente.Rut ? (cliente.Rut + "-" + DigitoVerificador(cliente.Rut)) : ""} fullWidth /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...direccionCesionario} /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...emailCesionario} /></Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>Datos Opcionales</Typography>
                <Grid container>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField label="Monto Cesión" error={monto > (cesionContext.state.documento.total || 0)} variant="outlined" helperText={monto ? ("Monto debe ser menor o igual a $" + separadorMiles(cesionContext.state.documento.total || 0)) : null} value={separadorMiles(monto)} onChange={e => setMonto(e.target.value.replace(/\./g, ""))} fullWidth /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" error={vencimiento.value && new Date(new Date(vencimiento.value).toLocaleDateString()) < new Date(new Date(cesionContext.state.documento.fecha_emision).toUTCString())} helperText={vencimiento.value ? ("Fecha debe ser mayor o igual a " + moment(cesionContext.state.documento.fecha_emision).format("DD/MM/YYYY")) : null} {...vencimiento} /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...otrasCondiciones} /></Typography></Grid>
                    <Grid xs={6}><Typography style={{ margin: 8 }} ><TextField variant="outlined" {...emailDeudor} /></Typography></Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container>
                    <Grid xs={12}>
                        <Typography style={{ margin: 8 }} >
                             <b>Declaración Jurada</b>
                            <Typography variant="caption">Yo, {DatosCeder.nombreRemitente}, RUN {DatosCeder.rutRemitente}-{DigitoVerificador(DatosCeder.rutRemitente)}, representando a {DatosCeder.RazonSocial}, RUT {DatosCeder.Rut}-{DigitoVerificador(DatosCeder.Rut)}, declaro que he puesto a disposición del cesionario {cliente.RazonSocial || "[INGRESE CESIONARIO]"}, RUT {cliente.Rut || "[INGRESE CESIONARIO]"}-{DigitoVerificador(cliente.Rut)}, el documento donde constan los recibos de la recepción de mercaderías entregadas o servicios prestados, entregados por parte del deudor de la factura {cesionContext.state.documento.razon_social}, RUT {cesionContext.state.documento.rut}-{DigitoVerificador(cesionContext.state.documento.rut)}, de acuerdo a lo establecido en la Ley N 19.983</Typography>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            {enviando?<LinearProgress variant="query"/>:null}
        </Grid>;

    const footer = (
        <DialogActions>
            <Button onClick={handleToggleModal} color="secondary" autoFocus>
                Cancelar
            </Button>
            <Button onClick={EnviaCesion} disabled={enviando} color="primary" autoFocus>
                Aceptar
            </Button>
        </DialogActions>
    );

    return (
        <div>
            <CloseButtonDialog open={cesionContext.state.openCesion} onClose={handleToggleModal} closeButton title={"Cesion " + cesionContext.state.documento.tipo_dte + " N°: " + cesionContext.state.documento.folio} content={cargando ? <div className={classes.progress}><CircularProgress disableShrink /></div> : content} footer={footer} size="md" />
        </div>
    );
}

export default withStyles(styles)(React.memo(Cesion));